import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '@/core/http'
import { Response } from '@/core'
import {
  AirportSuggestionsApiResponse,
  EventData,
  ExchangeRatesApiResponse,
  GlobalSearchApiResponse,
  HotelLocationApiResponse,
  UserLocationInfoParams,
  UserLocationInfoResponse,
} from '@/redux/lookup'

export const lookupApi = createApi({
  reducerPath: 'lookupApi',
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    eventList: builder.query<Response<EventData>, string>({
      query: (pageId) => ({
        url: `/lookup/events/${pageId}`,
        method: 'get',
      }),
    }),

    globalSearch: builder.query<Response<Partial<GlobalSearchApiResponse>>, string>({
      query: (searchQuery) => ({
        url: `/lookup/search/global`,
        method: 'get',
        params: { query: searchQuery },
      }),
    }),

    hotelLocations: builder.query<Response<HotelLocationApiResponse>, string>({
      query: (query) => ({
        url: `/lookup/search/hotel-locations`,
        method: 'get',
        params: { query },
      }),
    }),

    airportSuggestions: builder.query<Response<AirportSuggestionsApiResponse>, string>({
      query: (query) => ({
        url: `/lookup/search/airport-suggestions`,
        method: 'get',
        params: { query },
      }),
    }),

    userLocation: builder.query<Response<UserLocationInfoResponse>, UserLocationInfoParams>({
      query: (params) => ({
        url: `/lookup/user-location`,
        method: 'get',
        params,
      }),
    }),

    exchangeRates: builder.query<Response<ExchangeRatesApiResponse>, void>({
      query: () => ({
        url: `/lookup/exchange-rates`,
        method: 'get',
      }),
    }),
  }),
})

export const {
  useEventListQuery,
  useLazyEventListQuery,
  useGlobalSearchQuery,
  useLazyGlobalSearchQuery,
  useLazyHotelLocationsQuery,
  useLazyAirportSuggestionsQuery,
  useUserLocationQuery,
  useLazyUserLocationQuery,
  useLazyExchangeRatesQuery,
} = lookupApi

export default lookupApi.reducer
